var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12532_313946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 14H10",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5009 6.5C3.5009 5.30653 3.975 4.16193 4.81892 3.31802C5.66283 2.47411 6.80742 2 8.0009 2C9.19437 2 10.339 2.47411 11.1829 3.31802C12.0268 4.16193 12.5009 5.30653 12.5009 6.5C12.5009 8.73875 13.0196 10.5375 13.4321 11.25C13.476 11.3259 13.4991 11.4119 13.4991 11.4996C13.4992 11.5872 13.4763 11.6733 13.4326 11.7492C13.3889 11.8252 13.326 11.8883 13.2503 11.9324C13.1745 11.9764 13.0885 11.9997 13.0009 12H3.0009C2.91339 11.9995 2.82754 11.976 2.75195 11.9319C2.67636 11.8878 2.61367 11.8246 2.57014 11.7487C2.52661 11.6728 2.50377 11.5868 2.50391 11.4992C2.50404 11.4117 2.52714 11.3258 2.5709 11.25C2.98277 10.5375 3.5009 8.73813 3.5009 6.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12532_313946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.5acf8dc248d331f4441416f9b5f5b98e.svg";
export { ForwardRef as ReactComponent };